module.exports = __webpack_public_path__ + "static/media/comingsoon.7760c255.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/comingsoon.png
// module id = 456
// module chunks = 5